import './style.scss';

/**
 *
 * @param insertTo - selector
 * @param position - center or top
 */
const addLoader = (insertTo, position = 'center') => {
  if (insertTo && typeof insertTo === 'string') {
    const el = document.querySelector(`${insertTo}`);

    el.innerHTML += `
      <div class="Loader Loader--${position}-mode" data-loader>
        <div class="Loader__inner">
          <div class="Loader__left"><div class="Loader__anim"></div></div>
          <div class="Loader__right"><div class="Loader__anim"></div></div>
        </div>
      </div>
    `;
  }
};

export default addLoader;
